<template>
  <div>
    <div id="title_view"></div>
    <div class="page_link_view">
      <router-link to="/world_normal" class="r_link_btn activ_btn">
        <img :src="menu_image_normal" alt="menu_image_normal">
      </router-link>
      <!-- 4月公開版 -->
      <router-link to="world_hard" class="r_link_btn activ_btn">
        <img :src="menu_image_hard" alt="menu_image_hard">
      </router-link>
      <!-- 3月公開版 -->
      <!-- <router-link to="#" class="r_link_btn">
      <img :src="menu_image_hard_pre" alt="menu_image_hard">
      </router-link> -->
    </div>
  </div>
</template>

<script>
/**
 * 世界編 ゲーム選択メニュー
 * 
 * @vue-data {Object} [menu_image_normal] 世界がわかる初級編メニューイメージ
 * @vue-data {Object} [menu_image_hard] 世界がわかる上級編（公開版）メニューイメージ
 * @vue-data {Object} [menu_image_hard_pre] 世界がわかる上級編近日公開イメージ
 */

export default {
  name: "WorldMenu",

  data () {
    return {
      menu_image_normal: require("../assets/world_normal_menu.png"),
      menu_image_hard: require("../assets/world_hard_menu.png"),
      menu_image_hard_pre: require("../assets/world_hard_menu_pre.png")
    };
  },

  mounted () {
    this.$store.dispatch("setCurrentGame", { gameName: "World" }) // 保存
  }
};
</script>

<style lang="sass" src='../assets/common_style.sass'></style>
